import { TestLinkModalContent } from './TestLinkModalContent';
export default TestLinkModalContent;